export default function Badge({
    children,
    variant = "default",
    color,
}: React.PropsWithChildren<{ variant?: "default" | "landUse" | "acres" | "landUseDescription", color?: string; }>) {
    const variants = {
        default: "bg-[#21506F] text-white",
        landUse: "text-white",
        acres: "bg-[#E2E8F0] text-[#64748B]",
        landUseDescription: "bg-[#E2E8F0] text-[#64748B]",
    };

    return (
        <span
            className={`inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium ${variants[variant]}`}
            style={
            variant === "landUse" && color
                ? {
                    backgroundColor: color,
                    color: "#FFFFFF"
                    }
                : undefined
            }
        >
            {children}
        </span>
    );
}